export default __webpack_public_path__ + "static/media/homeDrawVector.bc55bb1a.jpg";